import axios from '../../axios';
import CCPaymentMessages from '../../content/CCPaymentMessages.js';

// Odata select string
const bookingSelect = `bookingItems($expand=transfer, itineraryDetail, service),
                      clientInvoice($expand=
                        bookingItemsPayable($expand=
                          RoomConfiguration,
                          PricingColumn,
                          property,
                          wine,
                          service,
                          itineraryDetail,
                          accounting_PaymentCurrency($select=totalPrice,bookingPaymentCurrencySymbol,balanceRemaining,damageWaiverDepositAmount),
                          relatedVillaBookingItem($expand=
                            property,
                            accounting_PaymentCurrency($select=totalPrice,bookingPaymentCurrencySymbol,balanceRemaining,damageWaiverDepositAmount)
                          ),
                          relatedWineBookingItems($expand=
                            wine
                          ),
                          relatedServiceBookingItems($expand=
                            service,
                            accounting_PaymentCurrency($select=totalPrice,bookingPaymentCurrencySymbol,balanceRemaining,damageWaiverDepositAmount)
                          )
                        )
                      ),
                      maxPricingColumn,
                      contact,
                      relatedWineBookingItems,
                      relatedInvoicedWineBookingItems($expand=
                        wine,
                        relatedVillaBookingItem
                      ),
                      NonInvoicedBookingItems,
                      relatedVillaBookingItemsForWine`;

const bookingSelect_ForPastBookings = 'clientInvoice($expand=bookingItemsPayable($expand=property,wine,service,accounting_PaymentCurrency($select=totalPrice,bookingPaymentCurrencySymbol,balanceRemaining,damageWaiverDepositAmount))),relatedVillaBookingItemsForWine';

const editBookingItemSelect = 'RoomConfiguration, PricingColumn, property, wine, service';

export default {
  namespaced: true,
  state: {
    currentBooking: null,
    currentBookingExpiresAt: null,
    updating: false,
    currentEditBookingItem: null, // booking item currently being edited (can be villa, service, experience)
    displayLoader: false,
    currentDamageWaiverDetails: null,
    currentBookingGuestNumbersInfo: null,
  },
  getters: {
    currentBooking: (state, getters) => {
      if (state.currentBooking) return state.currentBooking;
    },
    currentDamageWaiverDetails: (state, getters) => {
      if (state.currentDamageWaiverDetails) {
        return state.currentDamageWaiverDetails;
      }
    },
    currentEditBookingItem: (state, getters) => {
      if (state.currentEditBookingItem) return state.currentEditBookingItem;
    },
    displayLoader: (state) => state.displayLoader,
    isUpdating: (state, getters) => state.updating,
    isComplexVillaBooking: (state, getters) => {
      const booking = getters.currentBooking;
      if (!booking) return false;

      // Check if the stored snapshot flag is set
      if (booking.isComplexVillaBooking) return true;

      // For unconfirmed bookings, check live property data
      if (booking.clientInvoice && booking.clientInvoice.bookingItemsPayable) {
        return booking.clientInvoice.bookingItemsPayable.some(
          (item) => item.property && item.property.complexVilla === true,
        );
      }

      return false;
    },
    CCPaymentResponseMessage: (state, getters, rootState, rootGetters) => (status, passrequired, bookingtype, paymenttype) => {
      const response = CCPaymentMessages.Responses.find((r) => {
        if (r.PassRequired == null || r.PassRequired === passrequired) {
          const forStatus = r.For.find((f) => f == status);
          if (forStatus) {
            return r;
          }
        }
      });

      if (response) {
        let msg = '';
        if (response.Messages && response.Messages.length == 1) {
          msg = response.Messages[0];
        } else if (response.Messages && response.Messages.length > 1) {
          msg = response.Messages.find((m) => m.BookingType == bookingtype && m.PaymentType == paymenttype);
        }
        msg.Description = msg.Description.replace('##phonenumber##', rootGetters['common/getOfficeStatus'].officeNumber);
        return msg;
      }
    },

    CCPaymentResponseMessageForCheckout: (state, getters, rootGetters, rootState) => (cardPaymentResponse, bookingType, paymentType, tel) => {
      let res = '';
      if (cardPaymentResponse.payState === 'Success') {
        if (bookingType === 'villa' && paymentType === 'balance') {
          res = { Success: true, Heading: 'Many thanks for making your balance payment!', Description: 'Your holiday is on the horizon and you�ll be heading to the airport before you know it. Have you got everything planned? If not, we recommend you call on the invaluable assistance of your dedicated Specialist. Whether you need to rent a car, order some wine, or book a luxury boat charter, they�re here to make your life easy. They�re also experts in logistics and they�d be delighted to help you with rooming arrangements, check-in times, and all those other little details that you may not have had time to think about yet. Email your Specialist or call ##phonenumber## <br/> While they�re doing all the hard work, why not whet your holiday appetite by reading out our in-depth guides, downloading our destination Spotify playlists, and following us on Instagram?' };
        } else if (bookingType === 'villa' && paymentType === 'deposit') {
          res = { Success: true, Heading: 'Congratulations on your booking!', Description: 'Your deposit payment has been received. Many thanks for booking with us. <br/> What�s next? Well, it�s never too early to start planning the finer details of your holiday, and one of our dedicated Specialists will be in touch in good time to assist you with this. If you�d like to contact them sooner, please feel free to do so by emailing your Specialist. Their role is to make your holiday a logistical breeze, and they�ll be on hand to arrange any of our stress-busting extra services (airport transfers and in-villa car hire delivery*, in-villa wine and hamper deliveries, in-villa cooks, and much more), or Experiences (a unique range of thrilling adventures, cultural enrichments and gastronomic inspirations designed to transform a great holiday into a life-enhancing one). <br/> In the meantime, why not get into the holiday mood by checking out our destination guides, listening to our dedicated Spotify playlists, and following us on Instagram?' };
        } else if (bookingType === 'service' && paymentType === 'balance') {
          res = { Success: true, Heading: 'Thank you for your booking!', Description: "Your payment has gone through successfully. Should you wish to book any other extra services or Experiences for your holiday, please don't hesitate to contact your Specialist, {0}." };
        } else if (bookingType === 'service' && paymentType === 'deposit') {
          res = { Success: true, Heading: 'Thank you for your booking!', Description: "Your payment has gone through successfully. Should you wish to book any other extra services or Experiences for your holiday, please don't hesitate to contact your Specialist, {0}." };
        } else if (bookingType === 'wine') {
          res = { Success: true, Heading: 'Thank you!', Description: 'Your payment has been received. Your wine will be delivered to your villa for your arrival.' };
        }
      } else if (cardPaymentResponse.payState === 'Failed') {
        if (cardPaymentResponse.paymendFailedReason === 'TechnicalIssue' || cardPaymentResponse.paymendFailedReason === 'Declined_TechnicalIssues') {
          res = { Success: false, Heading: 'Payment failed', Description: 'We are sorry, there appears to be a problem with our payment system. Please try again a bit later.<br/> <br/>If you are experiencing difficulties and would prefer to speak to one of our team please call: ##phonenumber##' };
        } else if (cardPaymentResponse.paymendFailedReason === 'Declined_IncorrectDetails') {
          res = { Success: false, Heading: 'Payment failed', Description: 'We were unable to process your payment correctly. Authorisation was declined by your bank. Please can you check that your details are correct, or try a different card?<br/> <br/>If you are experiencing difficulties and would prefer to speak to one of our team please call: ##phonenumber##' };
        } else if (cardPaymentResponse.paymendFailedReason === 'Declined_CardThreeDSecureDisabled') {
          res = { Success: false, Heading: 'Payment failed', Description: '3D-Secure authentication failed. The card or card issuer is not part of the 3D-Secure scheme. <br/> If you are experiencing difficulties and would prefer to speak to one of our team please call: ##phonenumber##' };
        } else if (cardPaymentResponse.paymendFailedReason === 'Declined') {
          res = { Success: false, Heading: 'Payment failed', Description: 'We were unable to process your payment correctly. Authorisation was declined by your bank. Please contact your bank for further support, or try a different card?<br/> <br/>If you are experiencing difficulties and would prefer to speak to one of our team please call: ##phonenumber##' };
        } else if (cardPaymentResponse.paymendFailedReason === 'RiskResponse') {
          res = { Success: false, Heading: 'Payment failed', Description: 'We were unable to process your payment correctly. <br/> <br/>If you are experiencing difficulties and would prefer to speak to one of our team please call: ##phonenumber##' };
        } else if (cardPaymentResponse.threedSecureStatus === 'Failed') {
          res = { Success: false, Heading: 'Payment failed', Description: '3D-Secure authentication failed. <br/> <br/>If you are experiencing difficulties and would prefer to speak to one of our team please call: ##phonenumber##' };
        }

        res.Description = res.Description.replace('##phonenumber##', tel);
      }

      return res;
    },

    CCPaymentResponseMessageForEcommpay: (state, getters, rootGetters, rootState) => (outcome, bookingType, paymentType, tel) => {
      let res = '';
      if (outcome === 'success') {
        if (bookingType === 'villa' && paymentType === 'balance') {
          res = { Success: true, Heading: 'Many thanks for making your balance payment!', Description: 'Your holiday is on the horizon and you�ll be heading to the airport before you know it. Have you got everything planned? If not, we recommend you call on the invaluable assistance of your dedicated Specialist. Whether you need to rent a car, order some wine, or book a luxury boat charter, they�re here to make your life easy. They�re also experts in logistics and they�d be delighted to help you with rooming arrangements, check-in times, and all those other little details that you may not have had time to think about yet. Email your Specialist or call ##phonenumber## <br/> While they�re doing all the hard work, why not whet your holiday appetite by reading out our in-depth guides, downloading our destination Spotify playlists, and following us on Instagram?' };
        } else if (bookingType === 'villa' && paymentType === 'deposit') {
          res = { Success: true, Heading: 'Congratulations on your booking!', Description: 'Your deposit payment has been received. Many thanks for booking with us. <br/> What�s next? Well, it�s never too early to start planning the finer details of your holiday, and one of our dedicated Specialists will be in touch in good time to assist you with this. If you�d like to contact them sooner, please feel free to do so by emailing your Specialist. Their role is to make your holiday a logistical breeze, and they�ll be on hand to arrange any of our stress-busting extra services (airport transfers and in-villa car hire delivery*, in-villa wine and hamper deliveries, in-villa cooks, and much more), or Experiences (a unique range of thrilling adventures, cultural enrichments and gastronomic inspirations designed to transform a great holiday into a life-enhancing one). <br/> In the meantime, why not get into the holiday mood by checking out our destination guides, listening to our dedicated Spotify playlists, and following us on Instagram?' };
        } else if (bookingType === 'service' && paymentType === 'balance') {
          res = { Success: true, Heading: 'Thank you for your booking!', Description: "Your payment has gone through successfully. Should you wish to book any other extra services or Experiences for your holiday, please don't hesitate to contact your Specialist, {0}." };
        } else if (bookingType === 'service' && paymentType === 'deposit') {
          res = { Success: true, Heading: 'Thank you for your booking!', Description: "Your payment has gone through successfully. Should you wish to book any other extra services or Experiences for your holiday, please don't hesitate to contact your Specialist, {0}." };
        } else if (bookingType === 'wine') {
          res = { Success: true, Heading: 'Thank you!', Description: 'Your payment has been received. Your wine will be delivered to your villa for your arrival.' };
        }
      }
      else if (outcome === 'failure') {
        res = { Success: false, Heading: 'Payment failed', Description: 'We were unable to process your payment correctly. <br/> <br/>If you are experiencing difficulties and would prefer to speak to one of our team please call: ##phonenumber##' };
        res.Description = res.Description.replace('##phonenumber##', tel);
      }
      return res;
    },
  },

  mutations: {
    setCurrentBookingId(state, bookingid) {
      if (bookingid) $cookies.set('current_booking_id', bookingid, '3m', null, null, false);
      else $cookies.remove('current_booking_id');
    },
    setCurrentDamageWaiverDetails(state, details) {
      state.currentDamageWaiverDetails = details;
    },
    setCurrentBooking(state, booking) {
      state.currentBooking = booking;
      if (booking)
      // to get an accurate local expiry time
      // add the amount of milliseconds that we have on the server before item expires to the current local javascript time
      { state.currentBookingExpiresAt = moment().add(booking.bookingItems[0].optionExpiryMilliseconds, 'ms'); }
      else state.currentBookingExpiresAt = null;
    },
    setCurrentEditBookingItem(state, bookingItem) {
      state.currentEditBookingItem = bookingItem;
    },
    displayLoader(state, payload) {
      state.displayLoader = payload;
    },
    setCurrentBookingGuestNumbersInfo(state, data) {
      state.currentBookingGuestNumbersInfo = data;
    },
  },
  actions: {

    // select and set Booking by Booking Item ID
    selectBookingByBookingItemId({ commit, state, dispatch, getters }, bookingItemId) {

      return new Promise((resolve, reject) => {
        const odata = `$select=*&$expand=${bookingSelect}`;
        state.updating = true;
        axios.get(`/core/bookings/bookingitemid/${bookingItemId}?${odata.replace(/ /g, '')}`, {
        }).then((res) => {
          console.log('bookingid');
          console.log(res.data.id);
          commit('setCurrentBookingId', null);
          commit('setCurrentBooking', null);
          commit('setCurrentBookingId', res.data.id);
          commit('setCurrentBooking', res.data);
          state.updating = false;
          resolve(res.data);
        }).catch((error) => {
          if (error.response.status === 401) {
            // the user session expired so reset booking state
            commit('setCurrentBookingId', null);
            commit('setCurrentBooking', null);
          }
        });
      });
    },

    // Fetch user data for currently logged in user (JWT token)
    createOB({ commit, dispatch, getters }, data) {
      // convert dates to English locale before sending to server
      const from = moment(data.from, 'DD MMM YYYY');
      from.locale('en');
      data.from = from.format('DD MMM YYYY');
      const to = moment(data.to, 'DD MMM YYYY');
      to.locale('en');
      data.to = to.format('DD MMM YYYY');
      return new Promise((resolve, reject) => {
        axios.post('/core/bookings/ob', data).then((res) => {
          // set logged in cookie & user
          commit('users/setLoggedInUserToken', res.data.jwt, { root: true });
          commit('users/setLoggedInUser', { contact: res.data.contact }, { root: true });

          // fetch and update current booking (force API call)
          dispatch('bookings/selectBooking', res.data.bookingId, { root: true }).then(() => {
            resolve('success');
          });
        }).catch((error) => {
          reject(error.response);
        });
      });
    },
    selectBooking({ commit, dispatch, getters }, bookingId) {
      return new Promise((resolve, reject) => {
        commit('setCurrentBookingId', bookingId);
        dispatch('fetchCurrentBooking', { forceReload: true }).then((res) => {
          resolve(res);
        }).catch((err) => { reject(err); });
      });
    },
    downloadInvoice({ commit, dispatch, getters }, bookingId) {
      return new Promise((resolve, reject) => {
        axios.get(`/core/invoice/${bookingId}`, {
          headers: { Accept: 'application/pdf' },
          responseType: 'blob',
        }).then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
      });
    },
    fetchCurrentBooking({ commit, state, dispatch, getters }, data) {
      return new Promise((resolve, reject) => {
        if ($cookies.get('current_booking_id')) {
          if (!getters.currentBooking || (data && data.forceReload)) {
            // only call the api if the cookie exist and the currentBooking state is null OR ForceReload is TRUE

            const odata = `$select=*&$expand=${bookingSelect}`;
            state.updating = true;
            axios.get(`/core/bookings/${$cookies.get('current_booking_id')}?${odata.replace(/ /g, '')}`, {
            }).then((res) => {
              commit('setCurrentBooking', res.data);
              state.updating = false;
              resolve(res.data);
            }).catch((error) => {
              if (error.response.status === 401) {
                // the user session expired so reset booking state
                commit('setCurrentBookingId', null);
                commit('setCurrentBooking', null);
              }
            });
          }
          else resolve(getters.currentBooking);
        }
        else {
          resolve(null);
        }
      });
    },

    // returns information about Damage Waiver on the booking
    sendDamageWaiverRequest({ commit, state, dispatch, getters }, bookingId) {
      return new Promise((resolve, reject) => {
        axios.get(`/core/bookings/senddamagewaiverrequest/${bookingId}`, {
        }).then((res) => {
          resolve(res.data);
        }).catch((error) => {
          reject(error);
        });
      });
    },

    // returns information about Damage Waiver on the booking
    getDamageWaiverDetails({ commit, state, dispatch, getters }, data) {
      return new Promise((resolve, reject) => {
        axios.get(`/core/bookings/damagewaiverdetails/${data.bookingId}/forcheckout/${data.forCheckout}`, {
        }).then((res) => {
          resolve(res.data);
        }).catch((error) => {
          reject(error);
        });
      });
    },

    // add Damage Waiver to the villa booking item on checkout(adds to pending villa booking), and returns and sets updated damage waiver details for the booking
    setDamageWaiverOnCheckout({ commit, state, dispatch, getters }, states) {
      return new Promise((resolve, reject) => {
        // post to states to endpoint
        axios.post('/core/bookings/setDamageWaiver', states).then((res) => {
          resolve(res.data);
        }).catch((error) => {
          reject(error);
        });
      });
    },

    // add Damage Waiver item(s) either for an already Confirmed booking or to a Provisional booking(not during checkout)
    // will create a new Booking and add all damage waiver items to the new booking if the Villa booking is already Confirmed, else will add to Provisional villa booking
    addDamageWaiver({ commit, state, dispatch, getters }, states) {
      return new Promise((resolve, reject) => {
        // post to states to endpoint
        axios.post('/core/bookings/addDamageWaiver', states).then((res) => {
          resolve(res.data);
        }).catch((error) => {
          reject(error);
        });
      });
    },

    // Fetch all booking for contact(provisional, confirmed and past bookings)
    fetchAllForContact({ commit, dispatch, getters }, contactid) {
      commit('displayLoader', true);
      return new Promise((resolve, reject) => {
        const odata = `$select=*&$expand=
                      Provisional($expand=
                        ${bookingSelect}
                      ),
                      UpcomingConfirmed($expand=
                        ${bookingSelect}
                      ),
                      PastBookings($expand=
                        ${bookingSelect_ForPastBookings}
                      ),
                      WhitekeyBookings`;

        axios.get(`/core/bookings/contactid/${contactid}?${odata.replace(/ /g, '')}`, {
        }).then((res) => {
          const bookings = res.data;
          bookings.provisional = bookings.provisional.filter((item) => item.clientInvoice.bookingItemsPayable.length > 0);
          resolve(bookings);
          commit('sca/setUsersBookings', bookings, { root: true });
        });
      });
    },
    // Fetch all booking for contact(provisional, confirmed EXCLUDING past bookings)
    fetchAllForContactExcludingPastBookings({ commit, dispatch, getters }, contactid) {
      return new Promise((resolve, reject) => {
        const odata = `$select=*&$expand=
                      Provisional($expand=
                        ${bookingSelect}
                      ),
                      UpcomingConfirmed($expand=
                        ${bookingSelect}
                      ),
                      WhitekeyBookings`;

        axios.get(`/core/bookings/contactid/${contactid}/excludepastbookings?${odata.replace(/ /g, '')}`, {
        }).then((res) => {
          const bookings = res.data;
          bookings.provisional = bookings.provisional.filter((item) => item.clientInvoice.bookingItemsPayable.length > 0);
          resolve(bookings);
        });
      });
    },
    fetchAllAndRequested({ commit, dispatch, getters }, contactid) {
      return new Promise((resolve, reject) => {
        const odata = `$select=*&$expand=
                      Provisional($expand=
                        ${bookingSelect}
                      ),
                      UpcomingConfirmed($expand=
                        ${bookingSelect}
                      ),
                      PastBookings($expand=
                        ${bookingSelect_ForPastBookings}
                      ),
                      WhitekeyBookings`;

        axios.get(`/core/bookings/contactid/${contactid}?${odata.replace(/ /g, '')}`, {
        }).then((res) => {
          resolve(res.data);
        });
      });
    },
    extendCurrentOB({ commit, dispatch, getters }) {
      return new Promise((resolve, reject) => {
        // must be a Pending OB
        if (getters.currentBooking && getters.currentBooking.onlineBooking && getters.currentBooking.status === 0) {
          // only call the api if the cookie exist and the currentBooking state is null
          axios.put(`/core/bookings/ob/extend/${getters.currentBooking.id}`, {
          }).then((res) => {
            // reload booking from database
            dispatch('fetchCurrentBooking', { forceReload: true }).then(() => {
              resolve(res.data);
            });
          }).catch((err) => { reject(err); });
        }
        else reject(null);
      });
    },
    expireCurrentOB({ commit, dispatch, getters }) {
      return new Promise((resolve, reject) => {
        // must be a Pending OB
        if (getters.currentBooking && getters.currentBooking.onlineBooking && getters.currentBooking.status === 0) {
          // only call the api if the cookie exist and the currentBooking state is null
          axios.put(`/core/bookings/ob/expire/${getters.currentBooking.id}`, {
          }).then((res) => {
            commit('setCurrentBookingId', null);
            commit('setCurrentBooking', null);
            resolve(res);
          }).catch((err) => { reject(err); });
        }
        else reject(null);
      });
    },
    keepAliveCurrentOB({ commit, dispatch, getters }) {
      return new Promise((resolve, reject) => {
        // must be a Pending OB
        if (getters.currentBooking && getters.currentBooking.onlineBooking && getters.currentBooking.status === 0) {
          // only call the api if the cookie exist and the currentBooking state is null
          axios.put(`/core/bookings/ob/keepalive/${$cookies.get('current_booking_id')}`, {
          }).then((res) => {
            // reload booking from database
            dispatch('fetchCurrentBooking', { forceReload: true }).then(() => {
              resolve(res.data);
            });
            // refresh JWT token on each keepalive ping so that the user token do not expire before the booking option expire
            dispatch('users/refreshToken', null, { root: true });
          }).catch((err) => { reject(err); });
        }
        else {
          reject({ text: 'no online booking' });
        }
      });
    },

    // current logged in user pay for the current booking
    cardPayCurrentBooking({
      commit, dispatch, getters, rootGetters,
    }, data) {
      return new Promise((resolve, reject) => {
        if (rootGetters['users/loggedInUser'] && getters.currentBooking) {
          const currentBooking = getters.currentBooking;

          axios.post(`/core/bookings/client/pay/card/${currentBooking.id}`, data).then((res) => {
            // if part of response then update logged in cookie
            if (res.data.jwt && res.data.jwt != '') commit('users/setLoggedInUserToken', res.data.jwt, { root: true });

            if (res.data.contact) {
              // update Logged In User
              commit('users/setLoggedInUser', { contact: res.data.contact, coSignIn: res.data.coSignIn, coSignInRole: res.data.coSignInRole }, { root: true });
            }

            // fetch and update current booking (force API call)
            dispatch('bookings/selectBooking', res.data.bookingId, { root: true }).then(() => {
              resolve(res.data);
            });
          }).catch((error) => {
            reject(error);
          });
        }
      });
    },

    // current logged in user pay for the current booking (WITH PROVIDER CHECKOUT)
    cardPayCurrentBookingCHECKOUT({
      commit, dispatch, getters, rootGetters,
    }, data) {
      return new Promise((resolve, reject) => {
        if (rootGetters['users/loggedInUser'] && getters.currentBooking) {
          const currentBooking = getters.currentBooking;
          // set the cj event id
          data.cJEvent = $cookies.get('cje');
          axios.post(`/core/bookings/client/pay/card/checkout/${currentBooking.id}`, data).then((res) => {
            // console.log(res);

            // if part of response then update logged in cookie
            if (res.data.jwt && res.data.jwt != '') commit('users/setLoggedInUserToken', res.data.jwt, { root: true });

            if (res.data.contact) {
              // update Logged In User
              commit('users/setLoggedInUser', { contact: res.data.contact, coSignIn: res.data.coSignIn, coSignInRole: res.data.coSignInRole }, { root: true });
            }

            // fetch and update current booking (force API call)
            dispatch('bookings/selectBooking', res.data.bookingId, { root: true }).then(() => {
              resolve(res.data);
            });
          }).catch((error) => {
            reject(error);
          });
        }
      });
    },

    // current logged in user pay for the current booking (WITH PROVIDER ECOMMPAY)
    cardPayCurrentBookingEcommpay({
      commit, dispatch, getters, rootGetters,
    }, data) {
      return new Promise((resolve, reject) => {
        if (rootGetters['users/loggedInUser'] && getters.currentBooking) {
          const currentBooking = getters.currentBooking;
          // set the cj event id
          data.cJEvent = $cookies.get('cje');
          axios.post(`core/payments/clientCardPayment/${currentBooking.id}`, data).then((res) => {
            // console.log(res);

            // if part of response then update logged in cookie
            if (res.data.jwt && res.data.jwt != '') commit('users/setLoggedInUserToken', res.data.jwt, { root: true });

            if (res.data.contact) {
              // update Logged In User
              commit('users/setLoggedInUser', { contact: res.data.contact, coSignIn: res.data.coSignIn, coSignInRole: res.data.coSignInRole }, { root: true });
            }

            // fetch and update current booking (force API call)
            dispatch('bookings/selectBooking', res.data.bookingId, { root: true }).then(() => {
              resolve(res.data);
            });
          }).catch((error) => {
            reject(error);
          });
        }
      });
    },

    // Request Token call to Checkout to get Card Details pre-payment (used to determine if card is a Corporate card and if we need to add extra Charge)
    // requestCardTokenFromCheckout

    // current logged in user pay for the current booking
    cardPayGet3DResponse({
      commit, dispatch, getters, rootGetters,
    }, data) {
      return new Promise((resolve, reject) => {
        axios.post(`/core/bookings/client/pay/card/3dresponse/${data.batchCode}`, data.cardPaymentDetails).then((res) => {
          if (res.data.contact) {
            // update Logged In User
            commit('users/setLoggedInUser', { contact: res.data.contact, coSignIn: res.data.coSignIn, coSignInRole: res.data.coSignInRole }, { root: true });
          }

          if (res.data.bookingId > 0) {
            // fetch and update current booking (force API call)
            dispatch('bookings/selectBooking', res.data.bookingId, { root: true }).then(() => {
              resolve(res.data);
            });
          } else {
            resolve(res.data);
          }
        }).catch((error) => {
          reject(error);
        });
      });
    },

    // current logged in user pay for the current booking
    cardPayGet3DResponseCHECKOUT({
      commit, dispatch, getters, rootGetters,
    }, data) {
      return new Promise((resolve, reject) => {
        axios.post(`/core/bookings/client/pay/card/3dresponse/checkout/${data.batchCode}`).then((res) => {
          if (res.data.contact) {
            // update Logged In User
            commit('users/setLoggedInUser', { contact: res.data.contact, coSignIn: res.data.coSignIn, coSignInRole: res.data.coSignInRole }, { root: true });
          }

          if (res.data.bookingId > 0) {
            // fetch and update current booking (force API call)
            dispatch('bookings/selectBooking', res.data.bookingId, { root: true }).then(() => {
              resolve(res.data);
            });
          } else {
            resolve(res.data);
          }
        }).catch((error) => {
          reject(error);
        });
      });
    },

    // update booking trip details
    updateCurrentBookingTripDetails({ commit, dispatch, getters }, bookingTripDetails) {
      return new Promise((resolve, reject) => {
        if (getters.currentBooking) {
          axios.post(`/core/bookings/${getters.currentBooking.id}/tripdetails`, bookingTripDetails).then((res) => {
            // update current booking
            // fetch and update current booking (force API call)
            dispatch('bookings/selectBooking', res.data, { root: true }).then(() => {
              resolve(res);
            });
          }).catch((error) => {
            reject(error);
          });
        } else {
          resolve(null);
        }
      });
    },

    // save booking ancillaries preferences
    saveBookingPreferences({ commit, dispatch, getters }, preferences) {
      return new Promise((resolve, reject) => {
        if (getters.currentBooking) {
          axios.post(`/core/bookings/${getters.currentBooking.id}/ancillaries`, preferences).then((res) => {
            // update current booking
            // fetch and update current booking (force API call)
            dispatch('bookings/selectBooking', res.data, { root: true }).then(() => {
              resolve(res);
            });
          }).catch((error) => {
            reject(error);
          });
        } else {
          resolve(null);
        }
      });
    },

    // save complex villa / local specialist preferences
    saveComplexVillaPreferences({ commit, dispatch, getters }, preferences) {
      return new Promise((resolve, reject) => {
        if (getters.currentBooking) {
          axios.post(`/core/bookings/${getters.currentBooking.id}/complexvilla`, preferences).then((res) => {
            // update current booking
            // fetch and update current booking (force API call)
            dispatch('bookings/selectBooking', res.data, { root: true }).then(() => {
              resolve(res);
            });
          }).catch((error) => {
            reject(error);
          });
        } else {
          resolve(null);
        }
      });
    },

    selectCurrentEditBookingItem({ commit }, bookingItemId) {
      return new Promise((resolve, reject) => {
        // ALWAYS call the API and update the currentEditBookingItem
        const odata = `$select=*&$expand=${editBookingItemSelect}`;
        axios.get(`/core/bookingitems/${bookingItemId}?${odata.replace(/ /g, '')}`, {
        }).then((res) => {
          commit('setCurrentEditBookingItem', res.data);
          resolve(res.data);
        }).catch((error) => {
          // error ocurred so set the current Edit Booking Item to NULL
          commit('setCurrentEditBookingItem', null);
          reject(error);
        });
      });
    },

    // update booking trip details
    updateCurrentBookingItemDetails({ commit, getters }, bookingItemDetails) {
      return new Promise((resolve, reject) => {
        if (getters.currentEditBookingItem) {
          axios.post(`/core/bookingitems/${getters.currentEditBookingItem.id}`, bookingItemDetails).then((res) => {
            resolve(res);
          }).catch((error) => {
            reject(error);
          });
        } else {
          resolve(null);
        }
      });
    },

    // update booking payment currency and rate
    updateCurrentBookingPaymentCurrency({
      commit, state, dispatch, getters,
    }, currencyId) {
      return new Promise((resolve, reject) => {
        if (getters.currentBooking) {
          state.updating = true;
          axios.post(`/core/bookings/${getters.currentBooking.id}/setcurrency/${currencyId}`).then((res) => {
            // fetch and update current booking (force API call)
            dispatch('bookings/selectBooking', getters.currentBooking.id, { root: true }).then(() => {
              state.updating = false;
              resolve(res);
            });

            // set current ui currency
            commit('currencies/setCurrentCurrencyId', currencyId, { root: true });
          }).catch((error) => {
            reject(error);
          });
        } else {
          resolve(null);
        }
      });
    },

    // process booking for offline payment
    processBookingForOfflicePayment({ commit, dispatch, getters }, paymethod) {
      return new Promise((resolve, reject) => {
        if (getters.currentBooking) {
          axios.post(`/core/bookings/${getters.currentBooking.id}/processoffline/${paymethod}`).then((res) => {
            // fetch and update current booking (force API call)
            dispatch('bookings/selectBooking', getters.currentBooking.id, { root: true }).then(() => {
              resolve(res);
            });
          }).catch((error) => {
            reject(error);
          });
        } else {
          resolve(null);
        }
      });
    },

    // update the cjAffiliateBookingCode on the booking
    updateCjBookingCode({ commit, dispatch, getters }) {
      return new Promise((resolve, reject) => {
        // must be a Pending booking
        if (getters.currentBooking && getters.currentBooking.status === 0) {
          const cjData = {
            bookingId: getters.currentBooking.id,
            cJAffiliateBookingCode: getters.currentBooking.cjAffiliateBookingCode,
          };
          axios.put('/core/bookings/setcjaffiliatebookingcode', cjData).then((res) => {
            resolve(res);
          }).catch((err) => { reject(err); });
        }
        else reject(null);
      });
    },

    // fetch passport details for booking by booking id
    fetchGuestnumbersinfo({ state, commit }, id) {
      return new Promise((resolve, reject) => {
        if (id) {
          axios.get(`/core/bookings/guestnumbersinfo/${id}`).then((res) => {
            // console.log('data:' + res.data[0])
            commit('setCurrentBookingGuestNumbersInfo', res.data);
            resolve(res.data);
          }).catch((error) => { reject(error); });
        } else {
          resolve(null);
        }
      });
    },

    updateGuestnumbersInfo({ commit, getters, rootGetters }, data) {
      return new Promise((resolve, reject) => {
        axios.post(`/core/bookings/${data.villaBookingItemId}/guestnumbers`, data.guestNumbers).then((res) => {
          commit('setCurrentBookingPassportDetails', res.data);
          resolve(res);
        }).catch((error) => { reject(error); });
      });
    },

    updateAllergiesInfo({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.post(`/core/bookingitems/${data.bookingItemId}/allergies`, { allergies: data.allergies }).then((res) => {
          resolve(res);
        }).catch((error) => { reject(error); });
      });
    },

    fetchAllergiesInfo({ commit }, bookingItemId) {
      return new Promise((resolve, reject) => {
        if (bookingItemId) {
          axios.get(`/core/bookingitems/${bookingItemId}/allergies`).then((res) => {
            resolve(res.data);
          }).catch((error) => { reject(error); });
        } else {
          resolve(null);
        }
      });
    },

    fetchRoomConfiguration({ commit }, bookingItemId) {
      return new Promise((resolve, reject) => {
        if (bookingItemId) {
          axios.get(`/core/bookingitems/${bookingItemId}/roomconfiguration`).then((res) => {
            resolve(res.data);
          }).catch((error) => { reject(error); });
        } else {
          resolve(null);
        }
      });
    },

    updateRoomConfiguration({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.post(`/core/bookingitems/${data.bookingItemId}/roomconfiguration`, {
          singles: data.singles,
          doubles: data.doubles,
          twins: data.twins,
          triples: data.triples,
          quads: data.quads,
          sixBed: data.sixBed,
          bunkBeds: data.bunkBeds,
          cots: data.cots,
          sleepingArrangementsDescription: data.sleepingArrangementsDescription,
        }).then((res) => {
          resolve(res);
        }).catch((error) => { reject(error); });
      });
    },

  },
};
